module.exports = __webpack_public_path__ + "img/13.33f52f7b.jpg";